/* iter150AG Part 27 — inline "Learn more →" chip.
 *
 * Drops next to any field label in the Sequencing UI and opens the
 * app-wide Help drawer pre-scrolled to the matching article. Works
 * via the ``?help=<slug>`` deep-link the drawer already honours.
 */
import { useLocation, useNavigate } from "react-router-dom";
import { Question } from "@phosphor-icons/react";


export default function LearnMoreChip({ slug, label = "Learn more", testid }) {
  const location = useLocation();
  const navigate = useNavigate();
  function open(e) {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    const params = new URLSearchParams(location.search);
    params.set("help", slug);
    navigate({ search: params.toString() }, { replace: false });
  }
  return (
    <button type="button" onClick={open}
            data-testid={testid || `learn-more-${slug}`}
            title={`Open help: ${label}`}
            className="inline-flex items-center gap-0.5 text-[10px] font-bold uppercase tracking-wider text-blue-700 hover:text-blue-800 hover:underline transition-colors">
      <Question size={9} weight="bold" />
      {label} →
    </button>
  );
}
